// src/utils/routeFactory.js
import React from 'react'
import ProtectedRoute from './protectedRoute'

export const createProtectedRoute = (Component, path) => {
  const ProtectedComponent = (props) => (
    <ProtectedRoute requiredRoute={path}>
      <Component {...props} />
    </ProtectedRoute>
  )

  // Set display name for debugging
  ProtectedComponent.displayName = `Protected(${
    Component.displayName || Component.name || 'Component'
  })`

  return ProtectedComponent
}
